import { Link, LockOpened } from 'components/Icons';
export const questionOptions = [
  {
    title: 'Help Index',
    icon: <Link fill='#424242' size='12px' />,
  },
  {
    title: 'Solovis Academy',
    icon: <Link fill='#424242' size='12px' />,
  },
];

export const profileOptions = [
  {
    title: 'Sign Out',
    icon: <LockOpened fill='#424242' size='12px' />,
  },
];

export const AppModulesSort: Map<string, number> = new Map([
  ['Gateway', 0],
  ['Hub', 10],
  ['FundAnalytics', 20],
  ['Clarity', 30],
  ['Predict', 40],
  ['Risk', 50],
  ['SecurityAttribution', 60],
  ['BenchmarkBlender', 70],
  ['SolovisAcademy', 80],
  ['EVestment', 90],
  ['EVConnect', 100],
  ['DataPack', 110],
  ['Diagnostics', 110],
  ['eVestmentLEAP', 110],
  ['ExposureBasedComposites', 110],
  ['Permissions', 110],
  ['VEUParallel', 110],
]);
